import { Pipe, PipeTransform } from '@angular/core';
import { Config } from '../../models/ui.interfaces';

@Pipe({
  name: 'passengerNumber'
})

/**
 * Takes a Error Message object and replaces  passnumber string with passenger number.
 * @example
 *
 * Input
 * {
 *    invalidYearFieldCheckOfDOB: {
 *       "Whoops! We're sorry, please enter a valid Secure Flight Date of Birth for passenger { passNumber }."
 * }
 *
 * Output
 * {
 *    invalidYearFieldCheckOfDOB: {
 *       "Whoops! We're sorry, please enter a valid Secure Flight Date of Birth for passenger 1."
 * }
 * @constructor
 * @param {Config} errorMessages - Error Message object.
 * @param {number} passengerIndex - Passenger index.
 */
export class ErrorMessagePipe implements PipeTransform {
  transform(
    errorMessages: Config,
    passengerIndex: number,
    multipax: boolean
  ): Config {
    const messages = { ...errorMessages };
    const replaceString = multipax ? ' ' + (passengerIndex + 1).toString() : '';
    for (const errorKey in messages) {
      messages[errorKey] = messages[errorKey].replace(
        / { passNumber }/,
        replaceString
      );
    }
    return messages;
  }
}
